(() => {
  try {
    const cfg = window.__autoMarketFromLocale;
    if (!cfg || !cfg.enabled) return;
    if (window.Shopify && Shopify.designMode) return;
    if (!cfg.localizationUrl || !cfg.currentCountry || !cfg.currentLocale) return;

    const locale = String(cfg.currentLocale || '').toLowerCase();
    const currentCountry = String(cfg.currentCountry || '').toUpperCase();
    const defaultCountry = String(cfg.defaultCountry || '').toUpperCase();

    // Only auto-switch when we're still on the default market.
    if (!defaultCountry || currentCountry !== defaultCountry) return;

    const localeToCountry = cfg.localeToCountry || {};
    const mapped = localeToCountry[locale];
    if (!mapped) return;

    const targetCountry = String(mapped).toUpperCase();
    if (!targetCountry || targetCountry === currentCountry) return;

    const availableCountries = Array.isArray(cfg.availableCountries)
      ? cfg.availableCountries.map((c) => String(c).toUpperCase())
      : [];
    if (!availableCountries.includes(targetCountry)) return;

    // Prevent loops and repeated attempts in the same session.
    const storageKey = `__autoMarketFromLocale:${locale}:${targetCountry}`;
    if (window.sessionStorage && sessionStorage.getItem(storageKey) === '1') return;
    if (window.sessionStorage) sessionStorage.setItem(storageKey, '1');

    const body = new URLSearchParams();
    body.set('form_type', 'localization');
    body.set('utf8', '✓');
    body.set('country_code', targetCountry);
    body.set('locale_code', cfg.currentLocale);

    fetch(cfg.localizationUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString(),
      credentials: 'same-origin',
    })
      .catch(() => {
        // If the request fails, do nothing (we already set sessionStorage to avoid loops).
      })
      .finally(() => {
        // Reload so Liquid renders with the new localization.country (market/currency/etc).
        window.location.reload();
      });
  } catch (_) {
    // No-op
  }
})();


